import { useEffect, useState } from "react";

/**
 * テストモード（F017 等の開発中機能の表示切替）。
 * 全般設定ダイアログ「その他」タブのトグルで切り替え、localStorage で永続化する。
 * 通常は OFF。ON の場合のみ添付ファイル UI を表示する。
 */
const TEST_MODE_KEY = "chatisTodoTestMode";
const TEST_MODE_EVENT = "chatis-todo-testmode-changed";

export function isTestModeEnabled(): boolean {
  try {
    return localStorage.getItem(TEST_MODE_KEY) === "1";
  } catch {
    return false;
  }
}

export function setTestModeEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(TEST_MODE_KEY, enabled ? "1" : "0");
  } catch {
    // localStorage が使えない環境では何もしない（OFF 扱いのまま）
  }
  // 同一タブ内の購読コンポーネントへ即時反映させる（storage イベントは他タブのみ発火するため）
  window.dispatchEvent(new Event(TEST_MODE_EVENT));
}

export function useTestMode(): boolean {
  const [enabled, setEnabled] = useState<boolean>(isTestModeEnabled);

  useEffect(() => {
    const sync = () => setEnabled(isTestModeEnabled());
    window.addEventListener(TEST_MODE_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(TEST_MODE_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  return enabled;
}
